export const FOOD_ACCESS_POINT_CATEGORY_KEYS = Object.freeze({
  PLAZA_MERCADO: "PLAZA_MERCADO",
  FARMERS_MARKET: "FARMERS_MARKET",
  PRODUCE_SHOP: "PRODUCE_SHOP",
  BUTCHER: "BUTCHER",
  BAKERY: "BAKERY",
  FISHMONGER: "FISHMONGER",
  TIENDA: "TIENDA",
  CONVENIENCE: "CONVENIENCE",
  SPECIALTY_FOOD: "SPECIALTY_FOOD",
  UNKNOWN_FOOD: "UNKNOWN_FOOD",
});

export const FOOD_FRESH_FOOD_LAYER_OPTIONS = [
  {
    id: "foodFreshPlazasMarkets",
    label: "Plazas / markets",
    desc: "Plazas de mercado and farmers markets",
    defaultVisible: false,
    categories: ["PLAZA_MERCADO", "FARMERS_MARKET"],
  },
  {
    id: "foodFreshProduce",
    label: "Produce shops",
    desc: "Fruit, vegetable, and greengrocer shops",
    defaultVisible: false,
    categories: ["PRODUCE_SHOP"],
  },
  {
    id: "foodFreshButchers",
    label: "Butchers",
    desc: "Carnicerías and butcher shops",
    defaultVisible: false,
    categories: ["BUTCHER"],
  },
  {
    id: "foodFreshBakeries",
    label: "Bakeries",
    desc: "Panaderías and bakeries",
    defaultVisible: false,
    categories: ["BAKERY"],
  },
  {
    id: "foodFreshTiendas",
    label: "Tiendas / small groceries",
    desc: "Neighborhood tiendas; fresh food availability varies",
    defaultVisible: false,
    categories: ["TIENDA"],
  },
  {
    id: "foodFreshConvenience",
    label: "Convenience food",
    desc: "Convenience stores with limited fresh food",
    defaultVisible: false,
    categories: ["CONVENIENCE"],
  },
  {
    id: "foodFreshSpecialty",
    label: "Specialty food",
    desc: "Specialty fresh food shops",
    defaultVisible: false,
    categories: ["FISHMONGER", "SPECIALTY_FOOD"],
  },
  {
    id: "foodFreshNeedsReview",
    label: "Unknown / needs review",
    desc: "Admin only — ambiguous fresh food POIs",
    defaultVisible: false,
    adminOnly: true,
    categories: ["UNKNOWN_FOOD"],
  },
];

export const FRESH_FOOD_PUBLIC_EXPLANATION =
  "Fresh food sources include markets, produce shops, bakeries, butchers, tiendas, and other local food providers. These points help show food availability beyond supermarkets. Some categories may need review because small stores vary in what they actually sell.";

export const FRESH_FOOD_LIMITATION_NOTE =
  "Fresh food presence does not guarantee affordability, quality, opening hours, or stock.";

export function getFreshFoodLayerLabel(layerId) {
  return FOOD_FRESH_FOOD_LAYER_OPTIONS.find((option) => option.id === layerId)?.label || layerId;
}
